import { Component, OnInit, SimpleChanges , ViewChild, ElementRef, Input, ChangeDetectorRef, PLATFORM_ID, Inject, Optional } from '@angular/core';
import { Chart, registerables } from 'chart.js/auto';
import { StockDataService } from '../stock-data.service';
import 'chartjs-adapter-date-fns';
import { enUS } from 'date-fns/locale';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AnalystEstimateComponent } from '../analyst-estimate/analyst-estimate.component';
import { NewsBoxComponent } from '../news-box/news-box.component';
import { ChartStripComponent } from '../chart-strip/chart-strip.component';
import { Subscription, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormsModule } from '@angular/forms';
import { TickerTapeComponent } from '../ticker-tape/ticker-tape.component';
import HighchartsStock from 'highcharts/highstock';
import Highcharts from 'highcharts';
// import 'highcharts/modules/treemap';
// import 'highcharts/highcharts-more';
// import 'highcharts/modules/accessibility';

// import IndicatorsCore from 'highcharts/indicators/indicators';
// import vbp from 'highcharts/indicators/volume-by-price';
// import atr from 'highcharts/indicators/atr';
// import ema from 'highcharts/indicators/ema';
// import IndicatorsAll from 'highcharts/indicators/indicators-all';
// import DragPanes from 'highcharts/modules/drag-panes';
// import AnnotationsAdvanced from 'highcharts/modules/annotations-advanced';
// import PriceIndicator from 'highcharts/modules/price-indicator';
// import FullScreen from 'highcharts/modules/full-screen';
// import StockTools from 'highcharts/modules/stock-tools';
// import HeikinAshi from 'highcharts/modules/heikinashi';
// import HollowCandlestick from 'highcharts/modules/hollowcandlestick';
// import Accessibility from 'highcharts/modules/accessibility';
import { Meta, Title } from '@angular/platform-browser';
import { EconomicCalendarComponent } from '../economic-calendar/economic-calendar.component';
import { IS_BOT } from '../shared/tokens';

// if (typeof window !== undefined) {
//   IndicatorsCore(Highcharts);
//   vbp(Highcharts);
//   atr(Highcharts);
//   ema(Highcharts);
//   // Initialize the modules
//   IndicatorsAll(Highcharts);
//   DragPanes(Highcharts);
//   AnnotationsAdvanced(Highcharts);
//   PriceIndicator(Highcharts);
//   FullScreen(Highcharts);
//   StockTools(Highcharts);
//   HeikinAshi(Highcharts);
//   HollowCandlestick(Highcharts);
//   Accessibility(Highcharts);
// }



interface CustomOptions extends Highcharts.Options {
  indicators?: any[];
}

interface FinancialData {
  date: string;
  symbol: string;
  [key: string]: any; // Index signature for dynamic keys
}

@Component({
  selector: 'app-stock-chart',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, AnalystEstimateComponent, NewsBoxComponent, ChartStripComponent, NgxSkeletonLoaderModule, TickerTapeComponent, EconomicCalendarComponent],
  templateUrl: './stock-chart.component.html',
  styleUrls: ['./stock-chart.component.css','../../assets/highcharts/gui.css','../../assets/highcharts/popup.css'],
})
export class StockChartComponent implements OnInit {
  @ViewChild('stockChart') stockChartRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild(AnalystEstimateComponent) AnalystEstimateComponent: AnalystEstimateComponent | undefined;
  showAnalyst: boolean = true;
  
  public chart: any
  id: string = '';
  incomeStatementData: FinancialData[] = [];
  incomeStatementTableHeaders: string[] = [];
  metricsData: FinancialData[] = [];
  metricsTableHeaders: string[] = [];
  profileData: FinancialData[] = [];
  profileTableHeaders: string[] = [];
  activeButtonIndex: number | null = 0;
  image: string = '';
  hoveredColumn: number = -1;
  lastPx: number = -1;
  lastClose: number = -1;
  name: string = '';
  percentChg: number = -1;
  selectedTimeframe: string = '1D'; // Default value
  todayISOString: string='';
  oneWeekAgoISOString: string='';
  oneMonthAgoISOString: string = '';
  threeMonthAgoISOString: string = '';
  sixMonthAgoISOString: string = '';
  oneYearAgoISOString: string='';
  fiveYearsAgoISOString: string = '';
  previousID: string = '';
  peers: string[]=[];
  peersData: any = {}
  fromDate: string = '';
  toDate: string = '';
  exch: string = '';
  filings: any = [];
  filterText: string = '';
  display: boolean = true;
  isMobileMenuOpen: boolean = false;
  renderComplete: boolean = false;
  // symbols = ['ARM','NYCB','WW','RUM','SPOT','LAC','PLUG','NU','ELF','SOFI','CMG','PATH','BP','CPRT',
  //   'VS','SAVA','NKLA','LOW','JOBY','DNA','GOLD','OXY','SOUN','LCID','HOLO','AMD','AI','AVGO','WBD',
  //   'ULTA','CCL','VALE','SMR','SLB','DE','SE','CLF','KR','ALT','ASTS','PANW','EPD','ETSY','JBLU','FI',
  //   'PTON','BYDDF','NET','MELI','NOW','BB','GAP','CLOV','FNMA','QSR','NLY','DG','GEV','NVO','T','MAT',
  //   'SILV','CAVA','RBLX','PG','WM','LLY','NCLH','MSFT','SIRI','BIIB','HA','GME','TTWO','NSC','ADP', 'MODG',
  //   'SHOT','BMY','CMCSA','LVS','DLTR','AMAT','MSI','RKLB','NUE','SPCE','VLO','TSN','O','SNAP','ROKU',
  //   'SHW','PGR','ACLS','SPR','EDIT','CDE','DHI','GEO','ALB','WHR','GRAB','NTDOY','DECK','HKD','GIS',
  //   'NOVA','HUBS','AEM','CCCC','PCG','IVP','DRUG','DDD','EXPE','POET','PCT','Z','ADI','MP','TMO','BUD',
  //   'PDD','OKE','ROOT','SG','GSK','NOK','ALK','ACN','TKO','DUK','VICI','ADMA','D','ETN','HTZ','WEWKQ',
  //   'LNG','ANET','ODFL','CRLBF','ISRG','RS','CEG','GILD','ABAT','WYNN','PRU','UAL','LI','ENB','TEVA',
  //   'RUN','X','INO','HUT','OPEN','MMM','CCI','UNP','CTAS','ASAN','ZOM','WDAY','HL','HAL','SAP','DXCM',
  //   'KEYS','IOT','HSY','CART','MBLY','STEM','LUMN','KOSS','VRTX','PNC','MGM','MPC','U','SNPS','MASS',
  //   'ABR','MRVL','ICU','GCT','HCA','SHEL','GNS','BE','PENN','W','ON','SO','HON','AG','KEY','ANF','LUV',
  //   'ALAB','BIGGQ','ME','ET','PLNT','BROS','VKTX','NOC','LRCX','TMUS','MDT','EA','KMI','XPO','KLG','FIS',
  //   'NRG','DPZ','HPE','BMR','AMGN','PARA','HE','RTX','CCJ','AEP','SPIR','NEP','TFC','CSX','AA','INVE',
  //   'BSX','WISA','CMI','CB','WTI','EW','FICO','GFS','DHR','CHRS','CAN','WEN','BEAM','IRM','CLS','UBS','ELV',
  //   'CI','PPL','NATL','NAT','SLI','TMC','DUOL','VERB','CRON','HIVE','AGEN','GH','AZO','APD','BK','DOW',
  //   'GRMN','VIRT','BTCWF','LYV','ZIM','SYY','VRT','AUR','LULU','CHWY','NICE','DTE','WDC','GD','BLNK','PR','HMC','ADM','VFS','ORLY','IP','INFY','HDB','TD','ATOS','HBI','MPW','PM','AIG','RACE','ACHR','FFIE','FLO','HOG','PEGA','LEVI','FIVE','UAA','AMSC','VSCO','DD','BHC','OHI','OCEA','KODK','DAVE','SQM','UA','SWIN','MQ','WOOF','GLW','LUCY','HRL','EMR','SPRY','URI','ESTC','PL','AKAM','RF','DM','JWN','BILI','FSK','EH','LEU','CYN','ARRY','RNA','IQ','CING','BTU','BZFD','XRX','IRBT','FUTU','FIGS','NFE','LNC','CFG','ORC','BJ','SINT','COMP','ST','DLR','PAA','MULN','BALL','LW','FMC','DKS','GRND','SATS','VSAT','AMR','PH','ZI','INDO','WAL','FSM','TEAM','WEC','GPRO','AZN','CAR','KITT','PLCE','REI','PWR','ASO','DFS','POWL','OPRA','GTLB','GT','PPG','CHKP','CARS','CROX','RIG','AAL','BTI','IREN','DOC','SERV','SYM','NNE','PBR','NEE','BRCC','CHTR','RYCEY','YUM','RSLS','HOOD','ARR','BHP','AMT'];
  displayCount = 10; // Number of filings to display initially
  metrics: string[] = [
  'peRatio',
  'enterpriseValueOverEBITDA',
  'evToFreeCashFlow',
  'roic',
  'netCurrentAssetValue',
  'bookValuePerShare',
  'priceToSalesRatio',
  'netIncomePerShare'
  ];
/*  Highcharts: typeof Highcharts = Highcharts;*/
  chartOptions: Highcharts.Options | undefined;
  isBrowser: boolean;
  isBot:boolean = false;

  constructor(
    private stockDataService: StockDataService, 
    private route: ActivatedRoute, 
    @Inject(PLATFORM_ID) private platformId: Object,  // <-- Fix here 
    private elementRef: ElementRef,
    private titleService: Title, 
    private metaService: Meta, 
    @Optional() @Inject(IS_BOT) private isBotSSR: boolean=false) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if( this.isBrowser) {
      this.chartOptions = {};
      this.isBot = this.isBotSSR;
    } 

    Chart.register(...registerables);

  }

 

  ngOnInit(): void {

    this.route.paramMap.pipe(
      switchMap((params: any) => {
        // Use switchMap to handle asynchronous operations
        this.id = params.get('id').toUpperCase();
        this.exch = params.get('exch').toUpperCase();
        // Return a new observable (in this case, using of to emit the id synchronously)
        return of({ id: this.id, exch: this.exch });
      })
    ).subscribe(({ id, exch }: { id: string, exch: string }) => {
      this.id = id;
      this.exch = exch;

      // if (this.isBrowser) {
  
      //   if (!this.symbols.includes(this.id)) {
      //     this.addNoIndexMetaTag();
      //   }
      // }

      if (this.exch === 'CRYPTO' || this.exch === 'FOREX' || this.exch === 'COMMODITY') {
        this.display = false;
      } else {
        this.display = true;
      }
      this.setSEOData();
      const todayISOString = this.stockDataService.lastWrkDay;
      // Create a Date object for midnight of the current date
      const today = new Date(todayISOString);
      const fiveYearsAgo = new Date(today);
      fiveYearsAgo.setFullYear(today.getFullYear() - 5);
      this.fiveYearsAgoISOString = fiveYearsAgo.toISOString().split('T')[0];

      // ISO string for today
      this.todayISOString = today.toISOString().split('T')[0];

      this.getLastPx('1min');
      this.setActiveButton(0);
      this.previousID = this.id;
      this.peersData = {};
      this.renderAll();
      // this.renderPeers();
      if (!this.isBot && this.isChartDataReady()) {
        this.renderChart(this.fiveYearsAgoISOString);
      }

      // // this.renderIntradayChart('1min', this.todayISOString);
      // this.renderMetrics();
      // this.renderProfile();
      // this.renderPeers();
      // this.renderMetrics();
      // this.renderProfile();
      // this.renderIncomeStatement();
      // this.renderBalanceStatement();
      // this.renderCashStatement();
      // this.renderFilings();
    });


    const todayISOString = this.stockDataService.lastWrkDay;

    // Create a Date object for midnight of the current date
    const today = new Date(todayISOString);
   

    // ISO string for 1 week ago
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    this.oneWeekAgoISOString = oneWeekAgo.toISOString().split('T')[0];

    // ISO string for 1 month ago
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(today.getMonth() - 1);
    this.oneMonthAgoISOString = oneMonthAgo.toISOString().split('T')[0];

    // ISO string for 3 month ago
    const threeMonthAgo = new Date(today);
    threeMonthAgo.setMonth(today.getMonth() - 3);
    this.threeMonthAgoISOString = threeMonthAgo.toISOString().split('T')[0];

    // ISO string for 6 month ago
    const sixMonthAgo = new Date(today);
    sixMonthAgo.setMonth(today.getMonth() - 6);
    this.sixMonthAgoISOString = sixMonthAgo.toISOString().split('T')[0];

    // ISO string for 1 year ago
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    this.oneYearAgoISOString = oneYearAgo.toISOString().split('T')[0];

    // ISO string for 5 years ago
    const fiveYearsAgo = new Date(today);
    fiveYearsAgo.setFullYear(today.getFullYear() - 5);
    this.fiveYearsAgoISOString = fiveYearsAgo.toISOString().split('T')[0];

    this.fromDate = this.fiveYearsAgoISOString;
    this.toDate = this.todayISOString;
  }

  setSEOData(): void {
    const market = this.exch;
    const url = `https://www.lambdafin.com/financials/chart/${market}/${this.id}`;

    // Dynamic Title & Description
    const description = `${this.id} operates on the ${market} exchange, providing financial insights including key statements, analyst estimates, and news updates.`;
    const title = `${this.id} Stock Price & Financials on ${market} Exchange`;

    // Set the page title dynamically
    this.titleService.setTitle(title);

    // Set the meta description dynamically
    this.metaService.updateTag({ name: 'description', content: description });

    // JSON-LD Structured Data (Schema.org)
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": url,
      "description": description,
      "headline": title,
      "inLanguage": "en-US",
      "isAccessibleForFree": true,
      "author": {
        "@type": "Organization",
        "name": "LambdaFin"
      },
      "publisher": {
        "@type": "NewsMediaOrganization",
        "@id": "https://www.lambdafin.com/#publisher",
        "name": "LambdaFin"
      }
    };

    const corporationSchema = {
      "@context": "https://schema.org",
      "@type": "Corporation",
      "@id": url,
      "name": title,
      "description": description,
      "alternateName": this.id,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "url": url,
        "isAccessibleForFree": true
      },
      "tickerSymbol": this.id
    };

    // Inject Schema Data
    this.metaService.updateTag({ name: 'ld+json', content: JSON.stringify(websiteSchema) });
    this.metaService.updateTag({ name: 'ld+json', content: JSON.stringify(corporationSchema) });
  }

  addNoIndexMetaTag(): void {
    const metaTag = this.metaService.getTag('name="robots"');
    if (!metaTag) {
      this.metaService.addTag({ name: 'robots', content: 'noindex, follow' });
    }
  }

  private isChartDataReady(): boolean {
    // Check if all necessary data is available, or if a DOM element is ready
    return !!this.elementRef.nativeElement.querySelector('#chart-container');
  }

  ngAfterViewInit(): void {
    if (this.isChartDataReady() &&!this.renderComplete) {
      this.renderChart(this.fiveYearsAgoISOString);
    }
    // this.setActiveButton(0);
    // if( this.AnalystEstimateComponent) {
    //   this.showAnalyst = (this.AnalystEstimateComponent?.nDataPts> 0 );
    // }
  }

  updateSelectedTimeframe(timeframe: string): void {
    this.selectedTimeframe = timeframe;
    // Perform any additional actions based on the selected timeframe
    this.changeTimeframe();
  }

  setActiveButton(index: number): void {
    if (this.isBrowser && typeof window !== 'undefined' && window.innerWidth <= 1100) { // 68.75em * 16px = 1100px
      this.isMobileMenuOpen = false;
    }

    if (this.activeButtonIndex !== index || this.previousID!== this.id) {
      this.activeButtonIndex = index;
      this.clearChart();
      this.clearIncomeStatementData();
      this.handleActiveButtonChange();
    }
  }

  changeTimeframe(): void {
    // Implement your logic based on selectedTimeframe using a switch statement
    this.clearChart();

    switch (this.selectedTimeframe) {
      case '1W':
        this.renderChart(this.fiveYearsAgoISOString);
        break;
      case '1M':
        this.renderChart(this.oneMonthAgoISOString);
        break;
      case '3M':
        this.renderChart(this.threeMonthAgoISOString);
        break;
      case '6M':
        this.renderChart(this.sixMonthAgoISOString);
        break;
      case '1Y':
        this.renderChart(this.oneYearAgoISOString);
        break;
      case '5Y':
        this.renderChart(this.fiveYearsAgoISOString);
        break;
      default: // Default to '1D'
        this.renderChart(this.fiveYearsAgoISOString);
        break;
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  handleActiveButtonChange() {
    // Perform actions based on the change in activeButtonIndex
    switch (this.activeButtonIndex) {
      case 0:
        this.changeTimeframe();
        this.renderMetrics();
        this.renderProfile();
        break;
      case 1:
        this.renderIncomeStatement();
        break;
      case 2:
        this.renderBalanceStatement();
        break;
      case 3:
        this.renderCashStatement();
        break;
      case 4:
        this.renderCashStatement();
        break;
      case 5:
        this.renderPeers();
        break;
      case 6:
        this.renderFilings();
        break;
      default:
        // Handle default case or do nothing
        break;
    }
  }

  clearChart(): void {
    if (this.chart !== undefined) {
      this.chart.destroy();
    }
    this.chart = undefined;
  }

  clearIncomeStatementData() {
    this.incomeStatementData = []; // Clear the data array when showIncome is false
  }

  isDateInRange(date: string): boolean {
    const fromDateObj = new Date(this.fromDate);
    const toDateObj = new Date(this.toDate);
    const recordDateObj = new Date(date);
    return recordDateObj >= fromDateObj && recordDateObj <= toDateObj;
  }

  shouldSkipHeader(header: string): boolean {
    const headersToSkip = ['_id', 'reportedCurrency', 'cik', 'acceptedDate'];
    return headersToSkip.includes(header);
  }

  shouldBeDisplayed(key: string): boolean {
    // List of keys you want to display
    const allowedKeys = [
      'freeCashFlowPerShare',
      'peRatio',
      'freeCashFlowYield',
      'roic',
      'payoutRatio',
      'beta',
      'VolAvg',
      'LastDiv',
      'MktCap',
      'industry',
      'Price', 
      'change', 'dayLow',
      'dayHigh', 'yearHigh',
      'yearLow', 'marketCap',
      'priceAvg50', 'priceAvg200', 'volume',
      'avgVolume', 'open',
      'previousClose'
      // Add other keys if needed
    ];

    return allowedKeys.includes(key);
  }

  isNumeric(value: any): boolean {
    return !isNaN(value);
  }

  // Modify the render functions to return promises
  renderIncomeStatement(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.stockDataService.getIncomeStatement(this.id).subscribe((response: FinancialData[]) => {
        this.incomeStatementData = Object.values(response[0]).reverse();
        this.incomeStatementTableHeaders = Object.keys(this.incomeStatementData[0]).filter(key => key !== 'date' && key !== 'symbol');
        resolve();
      },
      (error) => {
        console.error('Error fetching data:', error);
        reject(error);
      });
    });
  }

  renderBalanceStatement(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.stockDataService.getBalanceStatement(this.id).subscribe((response: FinancialData[]) => {
        this.incomeStatementData = Object.values(response[0]).reverse();
        this.incomeStatementTableHeaders = Object.keys(this.incomeStatementData[0]).filter(key => key !== 'date' && key !== 'symbol');
        resolve();
      },
      (error) => {
        console.error('Error fetching data:', error);
        reject(error);
      });
    });
  }

  renderCashStatement(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.stockDataService.getCashStatement(this.id).subscribe((response: FinancialData[]) => {
        this.incomeStatementData = Object.values(response[0]).reverse();
        this.incomeStatementTableHeaders = Object.keys(this.incomeStatementData[0]).filter(key => key !== 'date' && key !== 'symbol');
        resolve();
      },
      (error) => {
        console.error('Error fetching data:', error);
        reject(error);
      });
    });
  }

  renderMetrics(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.exch === 'CRYPTO') {
        let metricsFields = ['price', 'changesPercentage', 'change', 'dayLow', 'dayHigh', 'yearHigh', 'yearLow', 'marketCap'];
        let profileFields = ['priceAvg50', 'priceAvg200', 'volume', 'avgVolume', 'open', 'previousClose', 'sharesOutstanding', 'name'];

        this.stockDataService.getCryptoData(this.id).subscribe((response: FinancialData[]) => {
          const filteredResponse = [metricsFields.reduce((acc: any, key: any) => {
            acc[key] = response[0][key];
            return acc;
          }, {})];

          const filteredResponse2 = [{
            [this.id]: profileFields.reduce((acc: any, key: any) => {
              acc[key] = response[0][key];
              return acc;
            }, {})
          }] as FinancialData[];

          this.metricsData = filteredResponse;
          this.profileData = filteredResponse2;
          this.metricsTableHeaders = Object.keys(this.metricsData[0]);
          this.profileTableHeaders = Object.keys(this.profileData[0][this.id]);
          this.name = this.profileData[0][this.id]['name'];
          resolve();
        });
      } else if (this.exch === 'FOREX') {
        let metricsFields = ['price', 'changesPercentage', 'change', 'dayLow', 'dayHigh', 'yearHigh', 'yearLow', 'marketCap'];
        let profileFields = ['priceAvg50', 'priceAvg200', 'volume', 'avgVolume', 'open', 'previousClose', 'sharesOutstanding', 'name'];

        this.stockDataService.getForexData(this.id).subscribe((response: FinancialData[]) => {
          const filteredResponse = [metricsFields.reduce((acc: any, key: any) => {
            acc[key] = response[0][key];
            return acc;
          }, {})];

          const filteredResponse2 = [{
            [this.id]: profileFields.reduce((acc: any, key: any) => {
              acc[key] = response[0][key];
              return acc;
            }, {})
          }] as FinancialData[];

          this.metricsData = filteredResponse;
          this.profileData = filteredResponse2;
          this.metricsTableHeaders = Object.keys(this.metricsData[0]);
          this.profileTableHeaders = Object.keys(this.profileData[0][this.id]);
          this.name = this.profileData[0][this.id]['name'];
          resolve();
        });
      } else {
        this.stockDataService.getV2KeyMetrics(this.id).subscribe((response: FinancialData[]) => {
          this.metricsData = response;
          this.metricsTableHeaders = Object.keys(this.metricsData[0]).filter(key => key !== 'date' && key !== 'symbol');
          resolve();
        },
        (error) => {
          console.error('Error fetching data:', error);
          reject(error);
        });
      }
    });
  }

  renderProfile(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.exch !== 'FOREX' && this.exch !== 'CRYPTO') {
        this.stockDataService.getProfile(this.id).subscribe((response: FinancialData[]) => {
          let symbol = response[0]['ticker'];
          this.profileData = response;
          this.image = this.profileData[0][symbol]['image'];
          this.name = this.profileData[0][symbol]['companyName'];
          this.profileTableHeaders = Object.keys(this.profileData[0][symbol]).filter(key => key !== 'date' && key !== 'Symbol');
          resolve();
        },
        (error) => {
          console.error('Error fetching data:', error);
          reject(error);
        });
      }
    });
  }

  async renderPeers(): Promise<void> {
    try {
      const [peersData, stockCandidates] = await Promise.all([
        this.stockDataService.stockPeers(this.id).toPromise(),
        this.stockDataService.stockList().toPromise()
      ]);

      this.peers = peersData?.[0]?.peersList || [];
      this.peers = [this.id, ...this.peers];

      const peerPromises = this.peers.map(async (stock) => {
        try {
          const [temp, temp2, realTime] = await Promise.all([
            this.stockDataService.getV2KeyMetrics(stock).toPromise(),
            this.stockDataService.getProfile(stock).toPromise(),
            this.stockDataService.getStockRealTimeData(stock).toPromise()
          ]);
          
          const stockData = stockCandidates.find((candidate: any) => candidate.symbol.toUpperCase() === stock.toUpperCase());
          
          this.peersData[stock] = {
            ...temp?.[0] || {},
            image: temp2?.[0]?.[stock]?.image || '',
            name: temp2?.[0]?.[stock]?.companyName || 'Unknown Company',
            price: realTime?.[0]?.price || 0,
            exchangeShortName: stockData?.exchangeShortName || ''
          };
        } catch (error) {
          console.error(`Failed to fetch data for stock ${stock}:`, error);
        }
      });

      await Promise.all(peerPromises);
    } catch (error) {
      console.error('Error fetching peers:', error);
    }
  }

  async renderFilings(): Promise<void> {
    try {
      this.filings = await this.stockDataService.getFilings(this.id).toPromise();
    } catch (error) {
      console.error('Error fetching filings:', error);
    }
  }

  // Method to load more items
  loadMore() {
    this.displayCount += 10; // Increase by 10 each time
  }

  // Fetch the last price data
  getLastPx(timeframe: string): void {
    this.stockDataService.getStockData(this.id).subscribe(data => {
      const stockData = data.historical.map((item: any) => ({
        date: new Date(item.date),
        price: item.close
      }));
      this.lastPx = stockData[0].price;
      this.lastClose = stockData[1].price;
      this.percentChg = (this.lastPx - this.lastClose) / this.lastClose;
    });
  }

  // Refactored to call all render functions concurrently
  async renderAll(): Promise<void> {
    try {
      await Promise.all([
        this.renderIncomeStatement(),
        this.renderBalanceStatement(),
        this.renderCashStatement(),
        this.renderMetrics(),
        this.renderProfile(),
        this.renderPeers(),
        this.renderFilings()
      ]);
    } catch (error) {
      console.error('Error rendering data:', error);
    }
  }


  renderChart(from:string): void {
    if(this.isBrowser && typeof window !== 'undefined' ) {
      this.stockDataService.getStockData(this.id).subscribe(data => {
        const stockData = data.historical. map((item: any) => ({
          date: new Date(item.date),
          close: item.close,
          low: item.low,
          high: item.high,
          open: item.open,
          volume: item.volume
        }));
        const filteredStockData = stockData.filter((item: any) => {
          const date = item.date;
          // Check if the date is greater than today
          const isAfterDate = date > new Date(from);
          // Check if the time is between 9:30am and 4pm
          return isAfterDate;
        });
  
        // Sort the filteredStockData by date (ascending order)
        filteredStockData.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());
  
  
        const dates = filteredStockData.map((item: any) => item.date);
        //const prices = filteredStockData.map((item: any) => item.price);
        const prices = filteredStockData.map((item: any) => item.close);
        const priceData = filteredStockData.map((item: any) => [
          new Date(item.date).getTime(), // Convert date to timestamp
          item.open,
          item.high,
          item.low,
          item.close
        ]);
  
        const volumeData = filteredStockData.map((item: any) => [
          new Date(item.date).getTime(), // Convert date to timestamp
          item.volume
        ]);
  
  
        var ctx = 'stockChart'; // jQuery instance
        var backgroundColor1 = '';
        var borderColor1 = '';
        if (prices[0] - prices[prices.length-1] >= 0) {
          backgroundColor1 = 'rgba(0, 180, 0, 0.25)';
          borderColor1 = 'rgba(0, 150, 0)';
        } else {
          backgroundColor1 = 'rgba(180, 0, 0, 0.25)';
          borderColor1 = 'rgba(150, 0, 0)';
        }
  
        const isSmallScreen = window.innerWidth <= 1100; // 68.75em * 16px = 1100px
        const chartOptions: CustomOptions = {
          chart: {
            style: {
              fontSize: isSmallScreen ? '200%' : '100%'
            }
          },
          title: {
            text: `${this.id} Stock Chart`, // Add chart title
            align: 'center' // Align the title to the center
          },
          xAxis: {
            type: 'datetime', // Set the x-axis type to datetime
            title: {
              text: 'Date' // Optional: Add a title for the x-axis
            }
          },
          yAxis: [{
            labels: {
              align: 'left'
            },
            height: '100%',
            resize: {
              enabled: true
            }
          }, {
            labels: {
              align: 'left'
            },
            top: '80%',
            height: '20%',
            offset: 0
          }],
          tooltip: {
            headerShape: 'callout',
            borderWidth: 0,
            shadow: false,
            positioner: function (width, height, point) {
              const chart = this.chart;
              let position;
  
              if (point.isHeader) {
                position = {
                  x: Math.max(
                    // Left side limit
                    chart.plotLeft,
                    Math.min(
                      point.plotX + chart.plotLeft - width / 2,
                      // Right side limit
                    )
                  ),
                  y: point.plotY
                };
              } else {
                position = {
                  x: point.series.chart.plotLeft,
                  y: point.series.chart.plotLeft
                };
              }
  
              return position;
            }
          },
          // rangeSelector: {
          //   buttonSpacing: isSmallScreen ? 15 : 10
          // },
          series: [{
            type: 'area',
            id: `${this.id}-ohlc`,
            
            name: `${this.id} Stock Price`,
            data: priceData,
            color: 'blue', // Color for down days
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                  [0, 'rgba(0, 100, 200, 0.5)'], // Lighter shade at the top
                  [1, 'rgba(0, 100, 200, 0.1)']  // Lighter shade at the bottom
              ]
            }
          }, {
            type: 'column',
              id: `${this.id} -volume`,
            name: `${this.id} Volume`,
            data: volumeData,
            yAxis: 1
          }],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 800,
                maxHeight: 10000
              },
              chartOptions: {
                rangeSelector: {
                  inputEnabled: false
                }
              }
            }]
          },
          // stockTools:{
          //   gui: {
          //     enabled:true
          //   }
          // }
        };
  
        Highcharts.chart(this.elementRef.nativeElement.querySelector('#chart-container'), {
          ...chartOptions,
         
        });
        this.renderComplete = true;
  
        //this.chart = new Chart(ctx, {
        //  plugins: [{
        //    id:'customCursor',
        //    afterDraw: (chart: any) => {
        //      if (chart.tooltip?._active?.length) {
        //        let x = chart.tooltip._active[0].element.x;
        //        let y = chart.tooltip._active[0].element.y;
        //        let yAxis = chart.scales.y;
        //        let xAxis = chart.scales.x;
        //        let ctx = chart.ctx;
        //        ctx.save();
        //        ctx.beginPath();
        //        ctx.moveTo(x, yAxis.right);
        //        ctx.lineTo(x, yAxis.bottom);
        //        ctx.moveTo(y, yAxis.right);
        //        ctx.lineTo(y, yAxis.top);
        //        ctx.lineWidth = 1;
        //        ctx.strokeStyle = 'rgba(0, 0, 255, 0.4)';
        //        ctx.stroke();
        //        ctx.restore();
  
                
        //      }
        //    }
        //  }],
        //  type: 'line',
        //  data: {
        //    labels: dates,
        //    datasets: [{
        //      label: 'Stock Prices',
        //      data: prices,
        //      backgroundColor: backgroundColor1,
        //      borderColor: borderColor1,
        //      borderWidth: 1,
        //      fill: true,
        //      pointRadius:0
        //    }]
        //  },
        //  options: {
        //    responsive: true,
        //    maintainAspectRatio: true,
        //    plugins: {
        //      legend: {
        //        display: false // Hides the legend
        //      }
        //    },
        //    scales: {
        //      x: {
        //        display: true,
        //        type: 'time',
        //        adapters: {
        //          date: {
        //            locale: enUS,
        //          }
        //        },
        //        title: {
        //          display: true,
        //          text: 'Date'
        //        },
        //        grid: {
        //          display: false, // Hides the grid lines on the x-axis
        //          color: 'rgba(0, 0, 0, 0)' // Removes any remaining border
        //        }
        //      },
        //      y: {
        //        display: true,
        //        title: {
        //          display: true,
        //          text: 'Price'
        //        },
        //        grid: {
        //          display: false, // Hides the grid lines on the x-axis
        //          color: 'rgba(0, 0, 0, 0)' // Removes any remaining border
        //        }
        //      }
        //    }
        //  }
        //});
         //this.chart.canvas.parentNode.style.height = '400px';
         //this.chart.canvas.parentNode.style.width = '400px';
      },
        error => {
          console.log('Error fetching data:', error);
        });
    }
  }

  async renderIntradayChart(timeframe:string, from:string): Promise<void> {
    const data = await this.stockDataService.getIntradayStockData(this.id, timeframe, from).toPromise();
    const stockData = data.map((item: any) => ({
      date: new Date(item.date),
      price: item.close
    }));
    const filteredStockData = stockData.filter((item: any) => {
      const date = item.date;
      // Check if the date is greater than today
      const isAfterDate = date > new Date(from);
      // Check if the time is between 9:30am and 4pm
      return isAfterDate;
    });

    const dates = filteredStockData.map((item: any) => item.date);
    const prices = filteredStockData.map((item: any) => item.price);

    var ctx = 'stockChart'; // jQuery instance
    var backgroundColor1 = '';
    var borderColor1 = '';
      
    if (prices[0] - prices[prices.length-1] >= 0) {
      backgroundColor1 = 'rgba(0, 180, 0, 0.25)';
      borderColor1 = 'rgba(0, 150, 0)';
    } else {
      backgroundColor1 = 'rgba(180, 0, 0, 0.25)';
      borderColor1 = 'rgba(150, 0, 0)';
    }

      this.chart = new Chart(ctx, {
      plugins: [{
        id:'customCursor',
        afterDraw: (chart: any) => {
          if (chart.tooltip?._active?.length) {
            let x = chart.tooltip._active[0].element.x;
            let y = chart.tooltip._active[0].element.y;
            let yAxis = chart.scales.y;
            let xAxis = chart.scales.x;
            let ctx = chart.ctx;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, yAxis.right);
            ctx.lineTo(x, yAxis.bottom);
            ctx.moveTo(y, yAxis.right);
            ctx.lineTo(y, yAxis.top);
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'rgba(0, 0, 255, 0.4)';
            ctx.stroke();
            ctx.restore();

              
          }
        }
      }],
      type: 'line',
      data: {
        labels: dates,
        datasets: [{
          label: 'Stock Prices',
          data: prices,
          backgroundColor: backgroundColor1,
          borderColor: borderColor1,
          borderWidth: 1,
          fill: true,
          pointRadius:0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false // Hides the legend
          }
        },
        scales: {
          x: {
            display: true,
            type: 'time',
            adapters: {
              date: {
                locale: enUS,
              }
            },
            title: {
              display: true,
              text: 'Date'
            },
            grid: {
              display: false, // Hides the grid lines on the x-axis
              color: 'rgba(0, 0, 0, 0)' // Removes any remaining border
            }
          },
          y: {
            display: true,
            title: {
              display: true,
              text: 'Price'
            },
            grid: {
              display: false, // Hides the grid lines on the x-axis
              color: 'rgba(0, 0, 0, 0)' // Removes any remaining border
            }
          }
        }
      }
    });
  }


  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(document.querySelector('.income-table'));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'table-data.xlsx');
  }

  objectKeys(obj: any) {
    return Object.keys(obj);
  }

}
